export default {
  methods: {
    searchResource (array, itemSearch) {
      let returnValue = null;
      // Check if array > 0
      if (array.length === 0) return null;

      array.forEach(element => {
        if (element.fileKey === itemSearch) {
          returnValue = element;
        }
      });

      return returnValue;
    },
    getDefaultResource (type) {
      let returnData = '';

      switch (type) {
        case 'Logotipo':
          returnData = require('@/assets/img/logo-dinapsis-aplicaciones.svg');
          break;
        case 'Imagen':
          returnData = require('@/assets/img/defecto.svg');
          break;
        case 'Video':
          returnData = '';
          break;
        default:
          returnData = '';
      }

      return returnData;
    },
    async getResources (entityName, entityId) {
      let returnData = null;
      this.showLoading();

      let dataArray = {
        EntityName: entityName,
        EntityId: entityId
      };

      let request = {
        controller: '/FileStorage',
        data: dataArray
      };

      await this.$store
        .dispatch('NGUD/getSuit', request)
        .then(response => {
          this.hideLoading();
          returnData = response.data;
        })
        .catch(err => {
          this.showError(err.message);
          this.hideLoading();
        });

      return returnData;
    },
    async saveFile (entityName, entityId, FileKey, File) {
      let dataArray = {
        EntityName: entityName,
        EntityId: entityId,
        FileKey: FileKey,
        File: File
      };

      let request = {
        controller: '/FileStorage',
        filter: {},
        contentType: 'multipart/form-data',
        body: dataArray
      };

      let responseData = null;

      await this.$store
        .dispatch('NGUD/postFile', request)
        .then(response => {
          responseData = {
            data: response.data,
            status: true
          };
        })
        .catch(err => {
          this.showError(err.message);

          responseData = {
            data: null,
            status: false
          };
        });

      return responseData;
    }
  }
};
